import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "@mui/material";

import { translate } from "i18n";
interface ICustomDialogProps {
  title: string;
  message: string;
  action: () => void;
  handleClose: () => void;
  open: boolean;
  disableAction?: boolean;
  confirmLabel?: string;
}

export class CustomDialog extends React.Component<ICustomDialogProps> {
  public state = { disabled: false };

  private triggerAction(): void {
    if (this.props.disableAction) {
      this.setState({ disabled: true });
    }
    this.props.action();
  }
  
  private triggerClose(): void {
    this.setState({ disabled: false });
    this.props.handleClose();
  }
  public render(): JSX.Element {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{this.props.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.triggerClose()} color="primary" data-cy="custom-dialog-cancel-button">
            {translate("cancel")}
          </Button>
          <Button
            onClick={() => this.triggerAction()}
            color="primary"
            data-cy="custom-dialog-ok-button"
            autoFocus
            disabled={this.state.disabled}>
            {translate(this.props.confirmLabel ? this.props.confirmLabel : "delete")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
